import React from 'react';
import styles from './imageSlider.module.css'; // Import CSS module

const ImageSlider = ({ slides }) => {
  return (
    <div className={styles.slider}>
      <div className={styles.slide} style={{ backgroundImage: `url(${slides?.image})` }}>
        <div className={styles.overlay}>
          <div className={styles.textContainer}>
            <h2 className={styles.title}>{slides?.title}</h2>
            <p className={styles.description}>{slides?.description}</p>
            <a href={slides?.buttonLink}>
              <button className={styles.button} >{slides?.buttonText}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
